import { render, staticRenderFns } from "./SupplierDefaults.vue?vue&type=template&id=519dfe92&"
import script from "./SupplierDefaults.vue?vue&type=script&lang=js&"
export * from "./SupplierDefaults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports